import { render } from "./InvoicePromiseToPayDetails.vue?vue&type=template&id=74336297&ts=true"
import script from "./InvoicePromiseToPayDetails.vue?vue&type=script&lang=ts"
export * from "./InvoicePromiseToPayDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__